import React from 'react';

export interface NewCampaignButtonProps {
  onClick: () => void;
  /** 'lg' = dashboard header CTA, 'sm' = compact contexts (selected campaign, team header) */
  size?: 'sm' | 'lg';
  className?: string;
}

/**
 * Shared "NEW CAMPAIGN" CTA — the white pill used in My Campaign View,
 * reused anywhere campaign creation is offered (team workspace, empty states).
 */
export const NewCampaignButton: React.FC<NewCampaignButtonProps> = ({
  onClick,
  size = 'lg',
  className = '',
}) => {
  const isCompact = size === 'sm';
  return (
    <button
      type="button"
      onClick={onClick}
      className={`group relative flex items-center bg-white rounded-xl text-black font-semibold tracking-wide hover:bg-gray-100 hover:scale-[1.02] shadow-lg shadow-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap ${
        isCompact ? 'gap-2 px-4 py-3 text-xs' : 'gap-3 px-6 py-3 text-sm'
      } ${className}`}
    >
      <span
        className={`rounded-full bg-black/10 flex items-center justify-center transition-colors group-hover:bg-black/15 ${
          isCompact ? 'w-4 h-4' : 'w-5 h-5'
        }`}
      >
        <svg
          className={`group-hover:rotate-90 transition-transform duration-300 ${
            isCompact ? 'w-3 h-3' : 'w-3.5 h-3.5'
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4" />
        </svg>
      </span>
      <span>NEW CAMPAIGN</span>
    </button>
  );
};
